import React from 'react';
import './IndiaGrowth.css';

const IndiaGrowth = () => {
  return (
    <section id="india-growth" className="india-growth section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Anchored in India: Macroeconomic Resilience and Opportunity</h2>
          <p className="section-subtitle">
            India's structural growth story and its impact on packaging industry demand
          </p>
        </div>

        <div className="growth-content">
          <div className="growth-visual">
              <div className="gdp-comparison">
                <h3>India's GDP Growth Leadership</h3>
                
                <div className="minimal-chart">
                  <div className="chart-bar">
                    <div className="bar-label">India</div>
                    <div className="bar-track">
                      <div className="bar-fill india" style={{ width: '68%' }}>
                        <span className="bar-value">6.8%</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="chart-bar">
                    <div className="bar-label">Global Average</div>
                    <div className="bar-track">
                      <div className="bar-fill global" style={{ width: '33%' }}>
                        <span className="bar-value">3.3%</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <p className="chart-caption">
                  India's projected Real GDP growth for FY 2025-26 compared to Global Average
                </p>
              </div>
          </div>

          <div className="growth-text">
            <div className="text-block left-aligned">
              <h4>Structural Growth Drivers</h4>
              <p>
                The structural growth of the Indian economy is driven by strong domestic demand, 
                robust public capital expenditure, and a highly resilient services sector, which 
                contributes ∼54% to Gross Value Added (GVA). This environment directly fuels 
                demand for durable packaging solutions across all sectors.
              </p>
            </div>

            <div className="text-block right-aligned">
              <h4>Global Growth Leadership</h4>
              <p>
                India is positioned as a global growth leader, supported by a stable macroeconomic 
                framework, including CPI inflation contained within the 4.5%–5.0% range, and a 
                credible fiscal consolidation path.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndiaGrowth;
